import { styled } from '@mui/material';

export const StyledEntitySwitchWrapper = styled('div')(() => ({
  overflow: 'hidden auto',
  maxHeight: 'calc(100vh - 64px)'
}));
